import React, { ReactNode } from 'react';
import { Skeleton } from 'src/components/ui';
import { useFormLoading } from './FormLoading';

export type ReadOnlyItem = { label: ReactNode; value: ReactNode };

/** Label/value pairs for data the user can see but not change. */
export function ReadOnlyList({ items }: { items: ReadOnlyItem[] }) {
  const loading = useFormLoading();

  return (
    <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 m-0 text-sm">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <dt className="opacity-70 font-normal">{item.label}</dt>
          <dd className="m-0 min-w-0 break-words">
            {loading ? (
              <Skeleton inline width="12rem" height="0.875rem" className="max-w-full" />
            ) : item.value === null || item.value === undefined || item.value === '' ? (
              '—'
            ) : (
              item.value
            )}
          </dd>
        </React.Fragment>
      ))}
    </dl>
  );
}

export default ReadOnlyList;
